export class Crime {
  ID: number;
  AGENCY_ID: number;
  AGENCY_NAME: string;
  REPORT_NUMBER: number;
  REPORT_DATE: Date;
  LOG_DATE: Date;
  REPORT_TIME: string;
  CRIME_TYPE_ID: number;
  CRIME_TYPE_DESCRIPTION: string;
  CRIME_TYPE: string = '';
  CRIME_TYPE_SUB: string;
  CRIME_PERIOD: string;
  CRIME_START: Date;
  CRIME_END: Date;
  LOCATION: string;
  DISPOSITION_ID: number;
  DISPOSITION_DESCRIPTION: string;
  CRIME_TYPE_UPDATED: boolean;
  DISPOSITION_UPDATED: boolean;
  SITECODE: string;
  SITE_NAME: string;
  INCIDENT_COUNT: number;
}

export class CrimeType {
  constructor(
    public TYPE_ID: number,
    public DESCRIPTION: string) { }
}

export class CrimeSubType {
  constructor(
    public ID: string,
    public TYPE: string,
    public PARENT: string,
    public CODE: string,
    public VALUE: string) { }
}

export class Disposition {
  constructor(
    public DISPOSITION_ID: number,
    public DESCRIPTION: string) { }
}

